import React from 'react';
import { Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller, Control } from 'react-hook-form';

interface AdditionalInfoSectionProps {
  control: Control<any>;
}

const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = ({ control }) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="birthday"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                label="Birthday"
                slotProps={{ textField: { fullWidth: true } }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="city"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Current City" fullWidth size="small" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="country"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Country" fullWidth size="small" />
            )}
          />
        </Grid>
      </Grid>

      <Controller
        name="notes"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Personal Notes"
            fullWidth
            multiline
            rows={4}
            placeholder="Hobbies, interests, last talked about..."
          />
        )}
      />
    </>
  );
};

export default AdditionalInfoSection;
